import './Masthead.scss';

import * as React from 'react';
import * as Core from 'components/core';

type Props = {
  title: string;
  children?: React.ReactNode;
};

export default function Masthead(props: Props) {
  return (
    <div className="Masthead">
      <Core.HeroHeading classes="t-heading-xl">
        {props.title}
      </Core.HeroHeading>
      {props.children && (
        <div className="Masthead-content t-heading-s u-color-text-light u-text-align-center">{props.children}</div>
      )}
    </div>
  );
}
